import OpenAccountBanner from './OpenAccountBanner';    
import OpenAccountSection from './OpenAccountSection';    

function OpenAccount() {
  return (
    <div>
    <OpenAccountBanner/>
    <OpenAccountSection/>
    </div>
  );
}

export default OpenAccount;